import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import TextInput from 'products/nomad_insurance/components/TextInput';
import { Icon, Label } from 'products/nomad_insurance/components/TextInput/styled';
import { ReactComponent as VisaIcon } from 'assets/img/icons/visa-icon.svg';
import { ReactComponent as MCIcon } from 'assets/img/icons/mc-icon.svg';
import CreditCardIcon from 'assets/img/icons/blank-credit-card.svg';
import { ReactComponent as AmexIcon } from 'assets/img/icons/amex-icon.svg';
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  CreditCardContainer,
  CustomInputWrapper,
  Row,
  IconRow
} from './styled';

const CreditCard = ({ formik, className }) => {
  const theme = useTheme();

  const inputStyle = {
    base: {
      fontSize: '16px',
      fontFamily: "'Helvetica Now', sans-serif",
      letterSpacing: '-0.02em',
      color: theme.colors.black,
      fontSmoothing: 'antialiased'
    },
    invalid: {
      color: theme.colors.black
    }
  };

  return (
    <CreditCardContainer className={className}>
      <CustomInputWrapper>
        <CardNumberElement
          label="Card number"
          name="creditCardNumber"
          formik={formik}
          options={{
            placeholder: '1234 1234 1234 1234',
            style: inputStyle
          }}
        />
        <Icon src={CreditCardIcon} alt="icon" />
        <Label isFieldValid="true">Card number</Label>
      </CustomInputWrapper>

      <TextInput label="Name on card" name="creditCardHolderName" formik={formik} />
      <Row>
        <CustomInputWrapper>
          <CardCvcElement
            name="creditCardCCV"
            hideInput
            formik={formik}
            options={{
              placeholder: 'CVC',
              style: inputStyle
            }}
          />
          <Label isFieldValid="true">CVV</Label>
        </CustomInputWrapper>
        <CustomInputWrapper>
          <CardExpiryElement
            name="creditCardExpiryDate"
            options={{
              placeholder: 'MM/YY',
              style: inputStyle
            }}
            formik={formik}
          />
          <Label isFieldValid="true">Expiry date</Label>
        </CustomInputWrapper>
      </Row>
      <Row>
        <IconRow>
          <VisaIcon />
          <MCIcon />
          <AmexIcon />
        </IconRow>
      </Row>
    </CreditCardContainer>
  );
};

CreditCard.propTypes = {
  formik: PropTypes.object,
  className: PropTypes.string
};

export default CreditCard;
